import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { RootState } from "store";
import UserRole from "enums/UserRole";
import useUpdateEffect from "hooks/useUpdateEffect";
import { BackButton, InlineLink, PrivacyTemplate } from "@mwi/ui";

const PrivacyPage = (): JSX.Element => {
  const navigate = useNavigate();

  const { user, practice, isAuthenticated } = useSelector(
    (state: RootState) => ({
      user: state.auth.user,
      practice: state?.practice,
      isAuthenticated: state.auth.authenticated,
    }),
  );

  const handleBack = () => {
    window.history.length > 0 ? navigate(-1) : navigate("/");
  };

  /* 
    Skip initial render, and then check condition after
    update render as Redux selector is null on initial render.
  */
  useUpdateEffect(() => {
    if (!isAuthenticated || user?.role === UserRole.MWI_ADMIN) {
      navigate("/");
    }
  }, [isAuthenticated, user?.role]);

  return (
    <div className="flex flex-col text-lg">
      <BackButton className="mb-14" onClick={handleBack} />

      <h1 className="mb-8">Privacy Policy</h1>

      <PrivacyTemplate
        email={practice?.email ?? null}
        phone={practice?.phone ?? null}
        address={practice?.address ?? null}
        displayName={practice?.displayName ?? null}
        privacyLink={practice?.privacyLink ?? null}
      />

      <br />

      <p>
        You can click <InlineLink to="/cookie">here</InlineLink> to view our
        cookie policy.
      </p>
    </div>
  );
};

export default PrivacyPage;
